/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {DiplomatObject} from 'types/DiplomatObject';
import {IPAccessRulesSettings} from 'types/diplomat/sftp/IPAccessRulesSettings';

export const VFSGroupNames = {
   name: 'name',
   userIds: 'userIds',
   allUsers: 'allUsers',

   includeLdapUsers: 'includeLdapUsers',
   ldapGroupFilter: 'ldapGroupFilter',

   accessRule: 'accessRule',
} as const;

export const VFSGroup = DiplomatObject.shape({
   [VFSGroupNames.userIds]: yup.array().of(yup.string()),
   [VFSGroupNames.allUsers]: yup.boolean(),
   [VFSGroupNames.includeLdapUsers]: yup.boolean(),
   [VFSGroupNames.ldapGroupFilter]: yup.string(),
   [VFSGroupNames.accessRule]: IPAccessRulesSettings,
});
export type IVFSGroup = yup.InferType<typeof VFSGroup>;
